interface PlanActionsRowProps {
  onPlanManual: () => void;
  onAutoplan: () => void;
  onProposal: () => void;
}

export default function PlanActionsRow(props: PlanActionsRowProps) {
  return null;
}






